import API from "@/api";

export const apiGetEnablePush = (fcm_token: string) => {
  return API.post("api/me/devices", { fcm_token: fcm_token });
};

export const apiGetDisableAllPush = () => {
  return API.delete("api/me/devices");
};
